import * as React from "react";
import { cn } from "../lib/utils";
import { LoadingSpinner } from "./loading-spinner";

interface LoadingStateProps extends React.HTMLAttributes<HTMLDivElement> {
  text?: string;
  size?: "sm" | "md" | "lg";
  fullScreen?: boolean;
}

export function LoadingState({ 
  className, 
  text = "Loading...",
  size = "md",
  fullScreen = false,
  ...props 
}: LoadingStateProps) {
  const containerClasses = fullScreen 
    ? "fixed inset-0 z-50 bg-background/80 backdrop-blur-xs" 
    : "";

  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-4",
        containerClasses,
        className
      )}
      {...props}
    >
      <LoadingSpinner size={size} />
      {text && (
        <p className="text-sm text-muted-foreground animate-pulse">{text}</p>
      )}
    </div>
  );
}

